import { render, staticRenderFns } from "./selectSizeModal.vue?vue&type=template&id=29b7404f&scoped=true"
import script from "./selectSizeModal.vue?vue&type=script&lang=js"
export * from "./selectSizeModal.vue?vue&type=script&lang=js"
import style0 from "./selectSizeModal.vue?vue&type=style&index=0&id=29b7404f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b7404f",
  null
  
)

export default component.exports